<script>
    import Image from '@project/components/Image.svelte'
    import { spring } from 'svelte/motion'
    import { dim } from '@project/utils'

    let urlPrefix = "/roxerdigital/404/";

    const { w, h } = dim()

    let el, img, car

    let c = spring({
        x1: w / 2,
        y1: -h / 2,
        x2: w,
        y2: h * 2,
        x3: w,
        y3: -h,
    }, {
        stiffness: 0.1,
        damping: 0.4
    })

    const load = (e) => {
        el = e.detail
        calc()
    }

    const resize = () => {
        calc()
    }

    const calc = () => {
        if(!img || !car) {
            return
        }

        let x = img.offsetLeft
        let x2 = car.getBoundingClientRect()
        
    }
</script>

<svelte:head>
    <style>
        html, body {
            height: 100%;
        }
    </style>
</svelte:head>

<svelte:window on:resize={resize}></svelte:window>

<main class="h-full flex flex-col">
    <section class="h-full flex justify-center text-center text-xl leading-relaxed text-roxerblack uppercase px-6">
        <article class="text-center">
            <p class="pl-0 text-left uppercase text:xl md:text-2xl my-12">
                Épp csak egy kicsi<br> hiányzott. <br> Próbálkozz újra!</p>
            <div class="w-full md:w-2/3 max-w-2xl mt-12">
                <Image on:load={load} height="321" jpg="{urlPrefix}media/Docky_poster.jpg" mp4="{urlPrefix}media/Docky_404.mp4" webm="{urlPrefix}media/Docky_404.webm" />
            </div>
            <div>
                    <img bind:this={car} alt="DeLorean DMC–12" style="width: 30em;" class="relative delorean w-ful -z-1 mt-12" src="{urlPrefix}media/delorean.svg">
            </div>
        </article>
        <aside class="h-full">
            <img alt="404" bind:this={img}
                class="overflow-hidden docky_404 fixed top-0 right-0 bottom-0 h-full w-2/5 md:mr-24 lg:mr-48"
                src="{urlPrefix}media/docky_404.svg">
        </aside>
    </section>
    <footer class="text-center pb-4 mt-24">
        <a class="inline-block" href="https://roxer.hu/">
            <img alt="A Roxer logója" class="w-8 md:w-12" src="{urlPrefix}media/roxer_logo_dark.png">
        </a>
    </footer>
</main>

<style>
    .img {
        max-width: 5em;
    }
</style>